module.exports = __webpack_public_path__ + "static/media/logo-new.45abaff8.png";